import { z } from "zod";
import { EncounterDiscussionHistoryEntrySchema } from "./encounter-discussion.js";
import { LetterTypeSchema } from "./letters.js";
import { ModelReleasePinSchema } from "./model-governance.js";
import { PatientProfileAssistantTranscribeRequestSchema } from "./patient-profile-assistant.js";
import { IdSchema } from "./primitives.js";
export const ENCOUNTER_ASSISTANT_PROMPT_VERSION = "encounter-assistant-v3";
export const ENCOUNTER_ASSISTANT_MAX_MESSAGE_LENGTH = 8_000;
const message = z.string().trim().min(1).max(ENCOUNTER_ASSISTANT_MAX_MESSAGE_LENGTH);
const text = z.string().trim().min(1).max(16_100);
export const EncounterAssistantInterpretRequestSchema = z
    .object({
    siteId: IdSchema,
    patientId: IdSchema,
    message,
    discussionHistory: z.array(EncounterDiscussionHistoryEntrySchema).max(8).optional(),
    clarification: z
        .object({ originalMessage: message, question: z.string().trim().min(1).max(1_000) })
        .strict()
        .optional(),
})
    .strict();
/** Editable intent proposals only. No codes, destinations, signing, dispatch or prescription payloads. */
export const EncounterAssistantProposalSchema = z.discriminatedUnion("kind", [
    z
        .object({
        kind: z.literal("note"),
        additions: z
            .array(z
            .object({
            section: z.enum(["subjective", "objective", "assessment", "plan"]),
            text: message,
        })
            .strict())
            .min(1)
            .max(4),
    })
        .strict(),
    z.object({ kind: z.literal("chart"), text }).strict(),
    z.object({ kind: z.literal("clinical_question"), text }).strict(),
    z
        .object({
        kind: z.literal("referral"),
        text,
        specialty: z.string().trim().min(1).max(200).optional(),
        urgency: z.enum(["routine", "soon", "urgent"]).optional(),
    })
        .strict(),
    z
        .object({
        kind: z.literal("orders"),
        text,
        category: z.enum(["laboratory", "imaging"]),
        testNames: z.array(z.string().trim().min(1).max(240)).min(1).max(25).optional(),
    })
        .strict(),
    z.object({ kind: z.literal("education"), text }).strict(),
    z.object({ kind: z.literal("needs_staff"), text }).strict(),
    z
        .object({
        kind: z.literal("letter"),
        text,
        letterType: LetterTypeSchema,
        dateText: z.string().trim().min(1).max(240).optional(),
        wording: z.string().trim().min(1).max(4_000).optional(),
    })
        .strict(),
    z.object({ kind: z.literal("prescription"), text }).strict(),
    z
        .object({
        kind: z.literal("follow_up"),
        text,
        timing: z.string().trim().min(1).max(240).optional(),
    })
        .strict(),
    z
        .object({ kind: z.literal("clarification"), question: z.string().trim().min(1).max(1_000) })
        .strict(),
]);
export const EncounterAssistantInterpretResponseSchema = z
    .object({
    proposal: EncounterAssistantProposalSchema,
    model: z.string().trim().min(1).max(160),
    promptVersion: z.literal(ENCOUNTER_ASSISTANT_PROMPT_VERSION),
    /** Server-selected model release; the actual task prompt version remains separate. */
    modelRelease: ModelReleasePinSchema.optional(),
})
    .strict();
export const EncounterAssistantTranscribeRequestSchema = PatientProfileAssistantTranscribeRequestSchema.extend({ patientId: IdSchema }).strict();
//# sourceMappingURL=encounter-assistant.js.map